export class EcCountry {

  ecCountryNum : number;
  libelle:String;
  code:String;
  codeLibelle:String;

  constructor(){
    this.ecCountryNum = null;
    this.libelle = null;
    this.code = null;

  }

  constructorCopy(country:EcCountry){
    this.ecCountryNum = country.ecCountryNum;
    this.libelle = country.libelle;
    this.code = country.code;
    this.codeLibelle = country.codeLibelle;
  }
}



// WEBPACK FOOTER //
// ./src/app/classes/country.ts